import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const showWebNavCart = () => {
  window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
};

const HeaderCart = ({ cartSize, classNames }) => {
  return (
    <div className={cx('website-title__cart', classNames)}>
      {cartSize > 0 && (
        <a role="button" className="cart-modal-link with-icon" onClick={showWebNavCart}>
          {cartSize > 0 && <span className="badge">{cartSize}</span>}
          <i className="zolaicon zolaicon-cart" />
        </a>
      )}
    </div>
  );
};

HeaderCart.propTypes = {
  cartSize: PropTypes.number,
  classNames: PropTypes.string,
};

export default HeaderCart;
